var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var BoxS = function (props) { return (React.createElement("svg", __assign({ viewBox: "0 0 960.01 960", width: "1em", height: "1em" }, props),
    React.createElement("defs", null),
    React.createElement("g", { id: "Layer_2", "data-name": "Layer 2" },
        React.createElement("g", { id: "icon" },
            React.createElement("path", { className: "cls-1", d: "M17.69 284.62l448 224a32 32 0 0 0 28.62 0l448-224a32 32 0 0 0 0-57.24l-448-224a32 32 0 0 0-28.62 0l-448 224a32 32 0 0 0 0 57.24zM480 67.78L856.45 256 480 444.22 103.55 256z" }),
            React.createElement("path", { className: "cls-1", d: "M17.69 508.62l448 224a32 32 0 0 0 28.62 0l448-224a32 32 0 0 0-28.62-57.24L480 668.22 103.55 480l70.76-35.38a32 32 0 1 0-28.62-57.24l-128 64a32 32 0 0 0 0 57.24z" }),
            React.createElement("path", { className: "cls-1", d: "M913.69 675.38L480 892.22 103.55 704l70.76-35.38a32 32 0 0 0-28.62-57.24l-128 64a32 32 0 0 0 0 57.24l448 224a32 32 0 0 0 28.62 0l448-224a32 32 0 1 0-28.62-57.24z" }))))); };
export default BoxS;
//# sourceMappingURL=BoxS.js.map